import requestFlow from '@/utils/requestFlow'
import { cashFlowRoutine, CASH_FLOW_DETAILS_CLEANUP, CASH_FLOW_FORECAST_CLEANUP, cashFlowForecastRoutine, cashflowForecastCleanupRoutine } from './routines'

export default {
  ...requestFlow(cashFlowRoutine).mockMutations,
  ...requestFlow(cashFlowForecastRoutine).mockMutations,

  [cashFlowRoutine.SUCCESS](state, payload) {
    state.cashFlowDetails = payload
    if (state.cashFlowDetailsError) {
      state.cashFlowDetailsError = null
    }
  },

  [cashFlowRoutine.FAILURE](state, payload) {
    state.cashFlowDetailsError = payload
  },

  [cashFlowForecastRoutine.SUCCESS](state, payload) {
    state.cashFlowForecast = payload
  },

  [CASH_FLOW_DETAILS_CLEANUP](state, payload) {
    Object.assign(state, payload)
  },

  [CASH_FLOW_FORECAST_CLEANUP](state, payload) {
    Object.assign(state, payload)
  }
}
